import { observer } from 'mobx-react';
import EditIcon from '../../../../../Cutesies/EditIcon';
import { LearningDesignSection } from '../../../Types';
import { useOpenable } from '../../../../../Modal/UseOpenable';
import LearningDesignDetails from './LearningDesignDetails';
import { sectionName } from './LearningDesignDetails/Form/FormHelpers';
import LearningCollectionEditStore from '../../../Edit/Store';

interface Props {
  section: LearningDesignSection;
  store: LearningCollectionEditStore;
}

function CustomizeLearningDesignDetails({ section, store }: Props) {
  const { open, close, modalState } = useOpenable();

  return (
    <>
      <div className="flex grow">
        <p className="mr-2 text-sm font-semibold">{sectionName(section)}</p>
        <div className="cursor-pointer" onClick={open}>
          <EditIcon />
        </div>
      </div>
      <LearningDesignDetails
        section={section}
        modalState={modalState}
        close={close}
        store={store}
      />
    </>
  );
}

export default observer(CustomizeLearningDesignDetails);
